module.exports = __webpack_public_path__ + "img/28.a6ccd050.jpg";